import { render, staticRenderFns } from "./AgeSlider.vue?vue&type=template&id=37992940"
import script from "./AgeSlider.vue?vue&type=script&lang=js"
export * from "./AgeSlider.vue?vue&type=script&lang=js"
import style0 from "./AgeSlider.vue?vue&type=style&index=0&id=37992940&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports